const styles = {
  inlineTable: 'policy-page--inlineTable',
  legals: 'policy-page--legals rio-page--legals',
  ul: 'policy-page--ul slds-list slds-list--dotted',
  ol: 'policy-page--ol slds-list slds-list--ordered'
};

export default styles;
